import { render, staticRenderFns } from "./ViewActivity.vue?vue&type=template&id=20330d90&scoped=true&"
import script from "./ViewActivity.vue?vue&type=script&lang=js&"
export * from "./ViewActivity.vue?vue&type=script&lang=js&"
import style0 from "./ViewActivity.vue?vue&type=style&index=0&id=20330d90&lang=scss&scoped=true&"
import style1 from "./ViewActivity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20330d90",
  null
  
)

export default component.exports